import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as objects from '../../../common/objects.js';
import { renderCodicons } from '../../../common/codicons.js';
import { escape } from '../../../common/strings.js';
export var HighlightedLabel = /*#__PURE__*/function () {
  function HighlightedLabel(container, supportCodicons) {
    _classCallCheck(this, HighlightedLabel);

    this.supportCodicons = supportCodicons;
    this.text = '';
    this.title = '';
    this.highlights = [];
    this.didEverRender = false;
    this.domNode = document.createElement('span');
    this.domNode.className = 'monaco-highlighted-label';
    container.appendChild(this.domNode);
  }

  _createClass(HighlightedLabel, [{
    key: "element",
    get: function get() {
      return this.domNode;
    }
  }, {
    key: "set",
    value: function set(text) {
      var highlights = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var escapeNewLines = arguments.length > 3 ? arguments[3] : undefined;

      if (!text) {
        text = '';
      }

      if (escapeNewLines) {
        // adjusts highlights inplace
        text = HighlightedLabel.escapeNewLines(text, highlights);
      }

      if (this.didEverRender && this.text === text && this.title === title && objects.equals(this.highlights, highlights)) {
        return;
      }

      if (!Array.isArray(highlights)) {
        highlights = [];
      }

      this.text = text;
      this.title = title;
      this.highlights = highlights;
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var htmlContent = '';
      var pos = 0;

      var _iterator = _createForOfIteratorHelper(this.highlights),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var highlight = _step.value;

          if (highlight.end === highlight.start) {
            continue;
          }

          if (pos < highlight.start) {
            htmlContent += '<span>';

            var _substring2 = this.text.substring(pos, highlight.start);

            htmlContent += this.supportCodicons ? renderCodicons(escape(_substring2)) : escape(_substring2);
            htmlContent += '</span>';
            pos = highlight.end;
          }

          if (highlight.extraClasses) {
            htmlContent += "<span class=\"highlight ".concat(highlight.extraClasses, "\">");
          } else {
            htmlContent += "<span class=\"highlight\">";
          }

          var _substring = this.text.substring(highlight.start, highlight.end);

          htmlContent += this.supportCodicons ? renderCodicons(escape(_substring)) : escape(_substring);
          htmlContent += '</span>';
          pos = highlight.end;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (pos < this.text.length) {
        htmlContent += '<span>';
        var substring = this.text.substring(pos);
        htmlContent += this.supportCodicons ? renderCodicons(escape(substring)) : escape(substring);
        htmlContent += '</span>';
      }

      this.domNode.innerHTML = htmlContent;

      if (this.title) {
        this.domNode.title = this.title;
      } else {
        this.domNode.removeAttribute('title');
      }

      this.didEverRender = true;
    }
  }], [{
    key: "escapeNewLines",
    value: function escapeNewLines(text, highlights) {
      var total = 0;
      var extra = 0;
      return text.replace(/\r\n|\r|\n/g, function (match, offset) {
        extra = match === '\r\n' ? -1 : 0;
        offset += total;

        var _iterator2 = _createForOfIteratorHelper(highlights),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var highlight = _step2.value;

            if (highlight.end <= offset) {
              continue;
            }

            if (highlight.start >= offset) {
              highlight.start += extra;
            }

            if (highlight.end >= offset) {
              highlight.end += extra;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        total += extra;
        return "\u23CE";
      });
    }
  }]);

  return HighlightedLabel;
}();